export default __webpack_public_path__ + "static/media/n-back-movement-step2.6d13db8d.svg";